// 在src/utils目录下创建一个dragDialog.js文件
import Vue from 'vue';

Vue.directive('dialog-drag', {
  bind(el, binding, vnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');

    dialogHeaderEl.style.cursor = 'move';

    // 绑定鼠标按下事件
    dialogHeaderEl.onmousedown = (e) => {
      // 获取初始鼠标位置
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      // 获取初始对话框位置
      let styL, styT;
      const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      }

      // 绑定鼠标移动事件
      document.onmousemove = function(e) {
        // 计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 设置对话框的新位置
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        // 阻止文本选择
        const selection = window.getSelection();
        selection.removeAllRanges();
      };

      // 绑定鼠标松开事件
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
